document.querySelectorAll('.accordion-title').forEach((accordionTitle) => {
  accordionTitle.addEventListener('click', () => {
    const accordionText = accordionTitle.nextElementSibling;
    const accordionIcon = accordionTitle.querySelector('.accordion-icon');
    const swiperWrapper = document.querySelector('.swiperThumbs .swiper-wrapper');

    accordionText.classList.toggle('open');
    accordionIcon.classList.toggle('rotate');
    
    if (accordionText.classList.contains('open')) {
      accordionText.style.maxHeight = accordionText.scrollHeight + "px";      
      swiperWrapper.classList.add('open');
    } else {
      accordionText.style.maxHeight = 0;
      swiperWrapper.classList.remove('open');
    }
  });
});

window.onload = function() {
  const firstAccordionTitle = document.querySelector('.warranty .accordion-title');
  if (firstAccordionTitle) {
    firstAccordionTitle.click();
  }
};